import $ from 'jquery';
window.$ = window.jQuery = $;

require('bootstrap');
require('jquery-lazy');
require('slick-carousel');

$(function() {
	$('.lazy').Lazy();
});

$(".product-slider").slick({
	lazyLoad: 'ondemand',
	prevArrow:'<div class="slider-nav slider-prev"><img src="/images/ui/prev.png" alt="Previous Slide" /></div>',
	nextArrow:'<div class="slider-nav slider-next"><img src="/images/ui/next.png" alt="Next Slide" /></div>'
});

stickyHeaderMargin();

$(window).resize(function() {
	stickyHeaderMargin();
}); 

$(window).scroll(function() {
	scrollToTop(this);
});

function scrollToTop(window){
	
	if ($('#to-the-top').length > 0){
		
		if ($(window).scrollTop() > 160) {
			$('#to-the-top').fadeIn();
		} else {
			$('#to-the-top').fadeOut();
		}
		
	}
	
}

function stickyHeaderMargin(){
	
	if ($(".sticky-top").length > 0 && $(".product-section").length > 0){
		
		var margin = $(".sticky-top").height();
		
		$(".product-section").each(function() {
			$(this).css('scroll-margin-top',margin);
		});
		$(".truck-type-header-wrap").each(function() {
			$(this).css('scroll-margin-top',margin);
		});
		$(".title.truck-family").each(function() {
			$(this).css('scroll-margin-top',margin);
		});
		
		$("#size-chart").css('scroll-margin-top',margin);

		
	}
	
}

$("#to-the-top").click(function() {
	$("html, body").animate({scrollTop: 0});
 });